import { DataFormats } from '@skylab-shared/constants';
import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';
import { format } from 'fecha';

export class DateIncludedInAccountingQuery extends Query<boolean> {
    public constructor(public readonly date: Date) {
        super();
    }
}

export class DateIncludedInAccountingQueryHandlerBase implements QueryHandler<DateIncludedInAccountingQuery, boolean> {
    private static Url = TaggedUrl.join('accounting/:date', [Tags.Api, Tags.NotHandle404]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: DateIncludedInAccountingQuery): Promise<boolean> {
        const date = format(query.date, DataFormats.date.webApi);
        const url = fillPlaceholders(DateIncludedInAccountingQueryHandlerBase.Url, { date });
        const result = await this.http.get<{ dateIncludedInAccounting: boolean; }>(url).then(response => response.data.dateIncludedInAccounting, () => false);
        return result;
    }
}
